import React, { useCallback, useEffect, useState } from 'react';
import ModuleHeader from '../../components/ModuleHeader/ModuleHeader';
import ModuleTable from '../../components/UtilityComponents/moduleTable';
import { DealerProgramAssociationCols } from '../../config/TableColumns';
import { Box } from '@mui/material';
import moment from 'moment';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { useSelector } from 'react-redux';
import DealerProgramAssocationDrawer from './DealerProgramAssocationDrawer';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { utility } from '../../utils';
var DealerProgramAssocation = function () {
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var portalSetupPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'ADMINISTRATOR:PORTAL_SETUP:DEALER_PROGRAM_ASSOCIATION'; });
    var canAdd = (portalSetupPermission === null || portalSetupPermission === void 0 ? void 0 : portalSetupPermission.Add) === 1;
    var canUpdate = (portalSetupPermission === null || portalSetupPermission === void 0 ? void 0 : portalSetupPermission.Update) === 1;
    var canDelete = (portalSetupPermission === null || portalSetupPermission === void 0 ? void 0 : portalSetupPermission.Delete) === 1;
    var _a = useState(), searchText = _a[0], setSearchText = _a[1];
    var _b = useState([]), adminList = _b[0], setAdminList = _b[1];
    var _c = useState([]), freezedList = _c[0], setFreezedList = _c[1];
    var _d = useState(false), isFetching = _d[0], setIsFetching = _d[1];
    var _e = useState(), rowData = _e[0], setRowData = _e[1];
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    var _g = useState(''), userAction = _g[0], setUserAction = _g[1];
    var _h = useState('all'), selectedPortal = _h[0], setSelectedPortal = _h[1];
    var _j = useState(undefined), vendorList = _j[0], setVendorList = _j[1];
    var _k = useState(false), deleteConfirmationOpen = _k[0], setDeleteConfirmationOpen = _k[1];
    var _l = useState(null), selectedProgramIdToDelete = _l[0], setSelectedProgramIdToDelete = _l[1];
    var getDealerProgramAssociationList = function () {
        setIsFetching(true);
        setAdminList([]);
        api_service.get({
            endPoint: api_urls.DEALER_PROG_ASSOCIATION_LIST,
            payLoad: {
                VendorId: selectedPortal == 'all' ? null : selectedPortal
            }
        }).then(function (res) {
            setIsFetching(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __adminList = res.data.data;
                __adminList.map(function (eachDealer, index) {
                    eachDealer.CreatedTime = moment(eachDealer.CreatedTime).tz('America/New_York');
                });
                setAdminList(__adminList);
                setFreezedList(__adminList);
            }
        }).catch(function (err) { setIsFetching(false); });
    };
    var tableActionHandler = function (rowData, actionType) {
        console.log('rowData:', rowData);
        console.log('actionType:', actionType);
        if (actionType == 'Edit') {
            setRowData(rowData);
            setUserAction('Edit');
            setOpen(true);
        }
        else if (actionType == 'Delete') {
            setSelectedProgramIdToDelete(rowData === null || rowData === void 0 ? void 0 : rowData.DealerAccountAspireOId);
            setDeleteConfirmationOpen(true);
        }
    };
    var handleDeleteProgramAssociation = function () {
        api_service.delete({
            endPoint: "".concat(api_urls.DELETE_DEALER_PROG_ASSOCIATION, "?DealerOId=").concat(selectedProgramIdToDelete),
        }).then(function (res) {
            var _a;
            if (res && res.data.statusCode === 200) {
                setSelectedProgramIdToDelete('');
                getDealerProgramAssociationList();
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message);
            }
        }).catch(function (err) {
            console.log("error in handleDeleteNotifications ");
        });
    };
    var handleViewDetails = function (__rowData) {
        console.log('handleViewDetails ~ rowData:', __rowData);
        setRowData(__rowData);
        setUserAction('View');
        setOpen(true);
    };
    var handleCreateAdmin = function () {
        setUserAction('Create');
        setOpen(true);
    };
    var handleClose = function () {
        setUserAction('');
        setRowData(null);
        setOpen(false);
    };
    useEffect(function () {
        var searchTerm = searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase();
        if (searchTerm === '') {
            setAdminList(freezedList);
        }
        else {
            var filteredResults = freezedList.filter(function (item) {
                var _a, _b, _c;
                return ((_a = item.DealerName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm)) ||
                    ((_b = item.DealerAccountAspireOId) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchTerm)) ||
                    ((_c = item.DealerAccountAspireId) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchTerm));
            });
            setAdminList(filteredResults);
        }
    }, [searchText]);
    useEffect(function () {
        if (selectedPortal) {
            getDealerProgramAssociationList();
        }
    }, [selectedPortal]);
    return (React.createElement(Box, { className: "common-module-wrapper user-management-wrapper" },
        React.createElement(ModuleHeader, { moduleName: 'Dealer Program Association', placeHolderText: 'Search by Dealer Name/OID/ID', hasPortalDD: true, hasStatusDD: false, hasSearch: true, hasAddItem: canAdd, hasAddItemName: 'Add Dealer - Program', getSelectedPortal: setSelectedPortal, selectedStatus: function () { }, getSearchedText: setSearchText, isDrawerOpen: function () { return handleCreateAdmin(); }, getVendorList: setVendorList, resetDealerFilters: freezedList === null || freezedList === void 0 ? void 0 : freezedList.length, feildWidth: 3.5, sx: {
                position: "sticky",
                top: "0px",
                zIndex: 3,
                paddingBottom: '10px',
                paddingTop: '10px'
            } }),
        React.createElement(Box, { className: "module-common-table-wrapper" },
            React.createElement(ModuleTable, { dataToDisplay: adminList, columns: DealerProgramAssociationCols, isLoading: isFetching, actionHandler: tableActionHandler, onClickHandler: handleViewDetails, isRowClickEnabled: true, moduleName: "Dealer Program Association", isActionColumn: canUpdate || canDelete, hideEditIcon: !canUpdate, hasDelete: canDelete })),
        React.createElement(Box, null,
            React.createElement(DealerProgramAssocationDrawer, { open: open, handleClose: handleClose, rowData: rowData, userAction: userAction, DealerProgramAssociationList: getDealerProgramAssociationList, canUpdate: canUpdate })),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: 'Are you sure?', message: 'Are you sure you want to delete this Dealer Program Association?', acceptBtnText: 'Yes', denyBtnText: 'No', acceptCallBack: useCallback(function () {
                console.log('acceptCallBack');
                handleDeleteProgramAssociation();
                setDeleteConfirmationOpen(false);
            }, [deleteConfirmationOpen]), denyCallBack: useCallback(function () {
                setSelectedProgramIdToDelete('');
                setDeleteConfirmationOpen(false);
            }, []), open: deleteConfirmationOpen, key: "".concat(deleteConfirmationOpen), cancelCallBack: useCallback(function () {
                setSelectedProgramIdToDelete('');
                setDeleteConfirmationOpen(false);
            }, []) })));
};
export default DealerProgramAssocation;
